import { breadcrumb } from './breadcrumb';

export const predictive_connect = {
  breadcrumb
 
};
